export default "__VITE_ASSET__T6yQh9BV__"